var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.flag
    ? _c("div", [
        !_vm.isSellerwell()
          ? _c(
              "div",
              {
                staticClass: "entry-lite-mini",
                class: { tooltipShow: _vm.tooltipShow },
                on: {
                  click: function ($event) {
                    return _vm.updateLiteGuide(1)
                  },
                },
              },
              [
                _c("span", { staticClass: "entry-lite-mini__text" }, [
                  _vm._v(" " + _vm._s(_vm.title) + " "),
                ]),
                _c(
                  "div",
                  { staticClass: "entry-lite-mini__star" },
                  [
                    _c("a-icon", {
                      class: { pass: _vm.guideInfo.guideSchedule[0] === "1" },
                      attrs: { type: "check-circle", theme: "filled" },
                    }),
                    _c("a-icon", {
                      class: { pass: _vm.guideInfo.guideSchedule[1] === "1" },
                      attrs: { type: "check-circle", theme: "filled" },
                    }),
                    _c("a-icon", {
                      class: { pass: _vm.guideInfo.guideSchedule[2] === "1" },
                      attrs: { type: "check-circle", theme: "filled" },
                    }),
                    _c("a-icon", {
                      class: { pass: _vm.guideInfo.guideSchedule[3] === "1" },
                      attrs: { type: "check-circle", theme: "filled" },
                    }),
                  ],
                  1
                ),
                _c("icon-font", {
                  attrs: { type: "gb-icon-a-xinshouyindao3" },
                }),
                _vm.tooltipShow
                  ? _c(
                      "div",
                      {
                        staticClass: "entry-lite-mini__tooltip",
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                          },
                        },
                      },
                      [
                        _vm._l(
                          _vm.progress.filter(
                            (find) =>
                              _vm.localDefaultConfig.lite[find.prop] >= 100
                          ),
                          function (item) {
                            return _c(
                              "div",
                              {
                                key: item.title,
                                on: {
                                  click: function ($event) {
                                    return _vm.toSeek(item.path)
                                  },
                                },
                              },
                              [
                                _c("a-icon", {
                                  staticStyle: {
                                    color: "rgba(82, 196, 26, 1)",
                                  },
                                  attrs: {
                                    type: "check-circle",
                                    theme: "filled",
                                  },
                                }),
                                _c("span", [_vm._v(_vm._s(item.success))]),
                              ],
                              1
                            )
                          }
                        ),
                        _c(
                          "i",
                          { on: { click: _vm.hideToolTip } },
                          [_c("a-icon", { attrs: { type: "down" } })],
                          1
                        ),
                      ],
                      2
                    )
                  : _vm._e(),
              ],
              1
            )
          : _vm._e(),
        _c("div", { staticClass: "entry-lite-tips" }, [
          _c("div", { staticClass: "tip-mask" }),
          _c("div", { staticClass: "tip-modal" }, [
            _c(
              "div",
              { staticClass: "tip-modal__title" },
              [
                _c("span", [_vm._v(_vm._s(_vm.title))]),
                _c("a-icon", {
                  staticClass: "close-icon",
                  attrs: { type: "close" },
                  on: {
                    click: function ($event) {
                      return _vm.updateLiteGuide(4)
                    },
                  },
                }),
              ],
              1
            ),
            _c("div", { staticClass: "tip-modal__main-wrapper" }, [
              _c("div", { staticClass: "tip-modal__main" }, [
                _c("div", { staticClass: "tip-modal__main--lf" }, [
                  _c("b", [_vm._v("欢迎您使用ECCANG ERP系统")]),
                  _c("p", [
                    _vm._v(
                      " 尊敬的易仓客户，欢迎您使用【ECCANG ERP系统】，我们是专注于亚马逊等平台的一站式精细化管理专家，我们是您的跨境业务首席增长官。 "
                    ),
                  ]),
                  _vm.videos[0]
                    ? _c("div", { staticClass: "video-main" }, [
                        _c("video", {
                          staticClass: "video-js",
                          attrs: {
                            id: "videoLiteBox",
                            src: _vm.videos[0].templateUrl,
                          },
                        }),
                      ])
                    : _vm._e(),
                  _c(
                    "ul",
                    { staticClass: "video-swiper" },
                    _vm._l(_vm.videos, function (video) {
                      return _c(
                        "li",
                        {
                          key: video.templateUrl,
                          staticClass: "video-item-ob",
                          class: {
                            cur: video.templateUrl === _vm.curVideo.templateUrl,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.changeVideo(video)
                            },
                          },
                        },
                        [
                          _c("div", {
                            style: { backgroundImage: `url(${video.img})` },
                          }),
                          video.templateUrl === _vm.curVideo.templateUrl
                            ? _c("i", { staticClass: "playing" }, [
                                _vm._v("播放中"),
                              ])
                            : _vm._e(),
                          _c("span", [_vm._v(_vm._s(video.businessCode))]),
                        ]
                      )
                    }),
                    0
                  ),
                ]),
                _c(
                  "div",
                  { staticClass: "tip-modal__main--rt" },
                  [
                    !_vm.guideInfo.guideSchedule.every((item) => item === "1")
                      ? [
                          _c(
                            "div",
                            {
                              staticClass: "step",
                              class: {
                                pass: _vm.guideInfo.guideSchedule[0] === "1",
                              },
                            },
                            [
                              _c("div", { staticClass: "step-top" }, [
                                _c("b", [_vm._v("第一步：店铺授权")]),
                                _vm.guideInfo.guideSchedule[0] === "0"
                                  ? _c(
                                      "p",
                                      { staticStyle: { width: "346px" } },
                                      [
                                        _vm._v(
                                          " 授权成功后，系统会立刻对该店铺的数据进行自动获取和展示。若您有多个店铺，首次授权时，建议选择单量较少的店铺，可以很快看到数据哦 "
                                        ),
                                      ]
                                    )
                                  : _c(
                                      "p",
                                      { staticStyle: { width: "356px" } },
                                      [
                                        _vm._v(
                                          " 1. 授权成功后，系统会立刻对该店铺的数据进行自动获取和展示。"
                                        ),
                                        _c("br"),
                                        _vm._v(
                                          "2. 若您有多个店铺，首次授权时，建议选择单量较少的店铺，可以很快看到数据哦 "
                                        ),
                                      ]
                                    ),
                                _vm.guideInfo.guideSchedule[0] === "1"
                                  ? _c(
                                      "div",
                                      { staticClass: "step-continue" },
                                      [
                                        _vm._m(0),
                                        _c(
                                          "div",
                                          [
                                            _vm.guideInfo.guideSchedule[2] ===
                                            "1"
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass: "inline-flex",
                                                    staticStyle: {
                                                      "margin-left": "10px",
                                                    },
                                                  },
                                                  [
                                                    _c("a-icon", {
                                                      attrs: {
                                                        type: "check-circle",
                                                        theme: "filled",
                                                      },
                                                    }),
                                                    _c("span", [
                                                      _vm._v("广告授权已完成"),
                                                    ]),
                                                  ],
                                                  1
                                                )
                                              : _c(
                                                  "a-button",
                                                  {
                                                    attrs: {
                                                      type: "primary",
                                                      size: "small",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.toAuth(2)
                                                      },
                                                    },
                                                  },
                                                  [_vm._v("去广告授权")]
                                                ),
                                            _vm.guideInfo.guideSchedule[3] ===
                                            "1"
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass: "inline-flex",
                                                    staticStyle: {
                                                      "margin-left": "10px",
                                                    },
                                                  },
                                                  [
                                                    _c("a-icon", {
                                                      attrs: {
                                                        type: "check-circle",
                                                        theme: "filled",
                                                      },
                                                    }),
                                                    _c("span", [
                                                      _vm._v("邮箱授权已完成"),
                                                    ]),
                                                  ],
                                                  1
                                                )
                                              : _c(
                                                  "a-button",
                                                  {
                                                    attrs: {
                                                      type: "primary",
                                                      size: "small",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.toAuth(3)
                                                      },
                                                    },
                                                  },
                                                  [_vm._v("去邮箱授权")]
                                                ),
                                          ],
                                          1
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _c(
                                  "div",
                                  { staticClass: "step-top__opt" },
                                  [
                                    _vm.guideInfo.guideSchedule[0] === "0"
                                      ? [
                                          _vm.userInfo.historicalStatus === 2
                                            ? _c(
                                                "div",
                                                [
                                                  _c("a-icon", {
                                                    staticStyle: {
                                                      color:
                                                        "rgba(250, 173, 20, 1)",
                                                    },
                                                    attrs: {
                                                      type: "exclamation-circle",
                                                      theme: "filled",
                                                    },
                                                  }),
                                                  _vm._v("未授权 "),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _c(
                                            "a-button",
                                            {
                                              attrs: {
                                                type: "primary",
                                                size: "small",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.toAuth(1)
                                                },
                                              },
                                            },
                                            [_vm._v("去授权")]
                                          ),
                                        ]
                                      : [
                                          _c(
                                            "div",
                                            [
                                              _c("a-icon", {
                                                staticStyle: {
                                                  color: "rgba(82, 196, 26, 1)",
                                                },
                                                attrs: {
                                                  type: "check-circle",
                                                  theme: "filled",
                                                },
                                              }),
                                              _vm._v(
                                                "已授权: " +
                                                  _vm._s(
                                                    _vm.guideInfo
                                                      .platformUserName
                                                  ) +
                                                  " "
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "a-button",
                                            {
                                              attrs: {
                                                type: "primary",
                                                ghost: "",
                                                size: "small",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.toAuth(1)
                                                },
                                              },
                                            },
                                            [_vm._v("授权更多")]
                                          ),
                                        ],
                                  ],
                                  2
                                ),
                              ]),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "step",
                              class: {
                                pass: _vm.guideInfo.guideSchedule[1] === "1",
                              },
                            },
                            [
                              _c("div", { staticClass: "step-top" }, [
                                _c("b", [_vm._v("第二步：自动拉取数据")]),
                                _vm._m(1),
                                _vm.guideInfo.guideSchedule[1] === "0" &&
                                _vm.guideInfo.guideSchedule[0] === "1"
                                  ? _c(
                                      "div",
                                      { staticClass: "step-top__opt" },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "opt-pull" },
                                          [_vm._v("拉取中…")]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              color: "rgba(0, 0, 0, 0.65)",
                                            },
                                          },
                                          [_vm._v(" 预计15-20分钟完成 ")]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]),
                              _vm._l(_vm.progress, function (item) {
                                return _c(
                                  "div",
                                  {
                                    key: item.title,
                                    staticClass: "progress-item",
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "progress-item__pct" },
                                      [
                                        _vm.guideInfo[item.prop] !== null
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.guideInfo[item.prop] + "%"
                                                )
                                              ),
                                            ])
                                          : _vm._e(),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "progress-item__pie" },
                                      [
                                        _c(
                                          "svg",
                                          {
                                            staticClass: "circular-chart",
                                            attrs: { viewBox: "0 0 42 42" },
                                          },
                                          [
                                            _c("path", {
                                              staticClass: "circle-bg",
                                              attrs: {
                                                d: "M21 6\n                            a 15.9155 15.9155 0 0 1 0 31.831\n                            a 15.9155 15.9155 0 0 1 0 -31.831",
                                              },
                                            }),
                                            _vm.guideInfo[item.prop] !== null
                                              ? _c("path", {
                                                  staticClass: "circle",
                                                  attrs: {
                                                    "stroke-dasharray": `${
                                                      _vm.guideInfo[item.prop]
                                                    }, 100`,
                                                    d: "M21 6\n                            a 15.9155 15.9155 0 0 1 0 31.831\n                            a 15.9155 15.9155 0 0 1 0 -31.831",
                                                  },
                                                })
                                              : _vm._e(),
                                            _c("image", {
                                              attrs: {
                                                "xlink:href": item.img,
                                                x: "13",
                                                y: "13",
                                                height: "18",
                                                width: "18",
                                              },
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "progress-item__content" },
                                      [
                                        _c("span", [
                                          _vm._v(_vm._s(item.title)),
                                        ]),
                                        _c("p", [
                                          _vm._v(_vm._s(item.subtitle)),
                                        ]),
                                      ]
                                    ),
                                    _vm.guideInfo[item.prop] >= 100 ||
                                    _vm.userInfo.historicalStatus === 1
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "progress-item__pass",
                                          },
                                          [
                                            _vm.guideInfo[item.prop] >= 100
                                              ? _c(
                                                  "div",
                                                  [
                                                    _c("a-icon", {
                                                      staticStyle: {
                                                        color:
                                                          "rgba(82, 196, 26, 1)",
                                                        "margin-right": "5px",
                                                      },
                                                      attrs: {
                                                        type: "check-circle",
                                                        theme: "filled",
                                                      },
                                                    }),
                                                    _vm._v("已完成 "),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            _c(
                                              "a-button",
                                              {
                                                attrs: { type: "link" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.toSeek(item.path)
                                                  },
                                                },
                                              },
                                              [_vm._v("去查看")]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]
                                )
                              }),
                            ],
                            2
                          ),
                        ]
                      : _c("div", { staticClass: "step-success" }, [
                          _c("b", [
                            _vm._v(
                              " 恭喜您，已经完成" +
                                _vm._s(_vm.title) +
                                "，速度超过"
                            ),
                            _c(
                              "span",
                              {
                                staticStyle: { color: "rgba(82, 196, 26, 1)" },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    Math.ceil(
                                      Math.random() * (94 - 80 + 1) + 80
                                    )
                                  ) + "%"
                                ),
                              ]
                            ),
                            _vm._v("以上的用户 "),
                          ]),
                          _vm._m(2),
                          _c("ul", [
                            _c(
                              "li",
                              [
                                _c("a-icon", {
                                  staticStyle: {
                                    color: "rgba(82, 196, 26, 1)",
                                  },
                                  attrs: {
                                    type: "check-circle",
                                    theme: "filled",
                                  },
                                }),
                                _vm._v(" 店铺授权 "),
                              ],
                              1
                            ),
                            _c(
                              "li",
                              [
                                _c("a-icon", {
                                  staticStyle: {
                                    color: "rgba(82, 196, 26, 1)",
                                  },
                                  attrs: {
                                    type: "check-circle",
                                    theme: "filled",
                                  },
                                }),
                                _vm._v(" 广告授权 "),
                              ],
                              1
                            ),
                            _c(
                              "li",
                              [
                                _c("a-icon", {
                                  staticStyle: {
                                    color: "rgba(82, 196, 26, 1)",
                                  },
                                  attrs: {
                                    type: "check-circle",
                                    theme: "filled",
                                  },
                                }),
                                _vm._v(" 邮箱授权 "),
                              ],
                              1
                            ),
                            _c(
                              "li",
                              [
                                _c("a-icon", {
                                  staticStyle: {
                                    color: "rgba(82, 196, 26, 1)",
                                  },
                                  attrs: {
                                    type: "check-circle",
                                    theme: "filled",
                                  },
                                }),
                                _vm._v(" 自动拉取数据 "),
                              ],
                              1
                            ),
                          ]),
                        ]),
                  ],
                  2
                ),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "tip-modal__footer" },
              [
                _vm.$env !== "production"
                  ? _c(
                      "a-button",
                      {
                        attrs: { type: "primary", ghost: "" },
                        on: { click: _vm.test },
                      },
                      [
                        _vm._v(
                          "走查用：模拟流程点这里（多次）" +
                            _vm._s(_vm.guideInfo.guideSchedule)
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm.guideInfo.guideSchedule[0] === "0" ||
                _vm.guideInfo.guideSchedule.every((item) => item === "1")
                  ? _c(
                      "a-button",
                      {
                        attrs: { type: "primary", ghost: "" },
                        on: {
                          click: function ($event) {
                            return _vm.updateLiteGuide(3)
                          },
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.guideInfo.guideSchedule.every(
                              (item) => item === "1"
                            )
                              ? "关闭引导"
                              : "不再提示"
                          )
                        ),
                      ]
                    )
                  : _vm._e(),
                !_vm.guideInfo.guideSchedule.every((item) => item === "1")
                  ? _c(
                      "a-button",
                      {
                        attrs: { type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.updateLiteGuide(4)
                          },
                        },
                      },
                      [_vm._v("收起引导")]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _vm._v(" 店铺授权已完成"),
      _c("br"),
      _vm._v(" 您可继续进行广告授权、邮箱授权 "),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticStyle: { width: "330px" } }, [
      _vm._v(" 1. 授权成功后，您即刻会在15-20分钟内看见以下数据。 "),
      _c("br"),
      _vm._v(
        " 2. Listing数据更新完后，只需维护成本一项，即刻获得多维度精细化利润报表，省去繁琐对账。"
      ),
      _c("br"),
      _vm._v(" 3. 优先更新最近24小时的订单 "),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("img", {
        attrs: { src: require("@/assets/img_noright.png"), alt: "" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }